import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ChatConversationDialogsService, hasConversationsSelector } from 'lib-trend-core/chat';

/**
 * The pane with nothing selected (desktop). On a phone the rail covers this route, so
 * the list is what the user sees at `/`.
 */
@Component({
  selector: 'chat-app-home',
  template: `
    @if (hasConversations$ | async) {
      <chat-empty-state
        class="flex-grow-1"
        icon="ri-chat-3-line"
        titleKey="chat.conversation.selectPrompt"
        hintKey="chat.conversation.selectPromptHint"
      ></chat-empty-state>
    } @else {
      <chat-empty-state
        class="flex-grow-1"
        icon="ri-chat-new-line"
        titleKey="chat.states.emptyConversations"
        hintKey="chat.states.emptyConversationsHint"
        actionKey="chat.states.startConversation"
        actionIcon="ri-chat-new-line"
        (action)="startConversation()"
      ></chat-empty-state>
    }
  `,
  host: { class: 'd-flex flex-column flex-grow-1' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatAppHomeComponent {

  readonly hasConversations$ = this.store.select(hasConversationsSelector);

  constructor(
    private readonly store: Store,
    private readonly conversationDialogs: ChatConversationDialogsService,
  ) { }

  startConversation(): void {
    this.conversationDialogs.openNewDirect();
  }
}
